import React, { useMemo } from 'react';
// import { allCountries } from 'country-region-data';
import { Country } from 'country-state-city';

import { Select } from 'antd';

interface Props {
  defaultValue: string;
  onValueChange?: (value: string) => void;
  [key: string]: unknown;
}

export const CountryDropdown: React.FC<Props> = ({
  defaultValue,
  onValueChange,
}) => {
  const allCountries = Country.getAllCountries();
  const options = useMemo(
    () =>
      allCountries.map(country => ({
        value: country.name,
        label: country.name,
      })),
    [allCountries],
  );
  return (
    <Select
      defaultValue={defaultValue}
      onChange={onValueChange}
      options={[{ value: '', label: '' }, ...options]}
    />
  );
};

CountryDropdown.defaultProps = {
  onValueChange: undefined,
};
